
<header>
    <div class="container-fluid">
        <div>
            <img [src]="logoSrc()" alt="">
        </div>
    </div>
</header>